import React from 'react';
import { Mechanics, GlobalLayout } from '../';

const MechanicsPage = (props) => (
  <GlobalLayout>
    <Mechanics {...props} />
  </GlobalLayout>
);

export default MechanicsPage;